/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankDataLookupOutcome {
    SUCCESS = 'SUCCESS',
    INVALID = 'INVALID',
    UNAVAILABLE = 'UNAVAILABLE',
}
